<template>
  <div>
    <v-container class="pa-5">
      <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl">
        Fidelidade
      </h1>

      <v-divider></v-divider>
      <v-form ref="form" v-model="valid" class="pa-5">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="termoQuery"
              prepend-inner-icon="mdi-magnify"
              label="Pequise por nome"
              :rules="inputRules"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="5" sm="2">
            <v-text-field
              :rules="inputRules"
              label="Data inicial"
              type="date"
              v-model="dataIni"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="5" sm="2">
            <v-text-field
              :rules="inputRules"
              label="Data final"
              type="date"
              v-model="dataFim"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" sm="2">
            <v-btn
              fab
              class="green"
              @click="buscarCliente()"
              :disabled="!valid"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <!-- <v-btn
              fab
              dark
              class="green"
              @click="converterAgendamentos()"
              
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn> -->
          </v-col>
        </v-row>
      </v-form>
      <p class="grey--text">
        *Resultados de no máximo 40 consultas/visitas (banco de dados possui
        limite gratuito de pesquisas)
      </p>
      <br />

      <div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Cliente
                </th>
                <th class="text-left">
                  Email
                </th>
                <th class="text-left">
                  Visitas
                </th>
                <th class="text-center">
                  Cartão Fidelidade
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in listaFidelidade" :key="item.email">
                <td>{{ item.nome }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.totalVisitas }}</td>
                <td>
                  <div class="text-center">
                    <CartaoFidelidade :item="item" />
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- 
      <div class="pa-2">
        <v-row v-for="item in listaFidelidade" :key="item.email">
          <v-card class="pa-5">
            <v-row>
              <v-col cols="12" sm="12">
                <v-row>
                  <span class="pt-1">Cliente: </span>
                  <h2>{{ item.nome }}</h2>
                </v-row>
                <h4>Email: {{ item.email }}</h4>
                <h4>Visitas: {{ item.totalVisitas }}</h4>
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </div> -->
    </v-container>
  </div>
</template>

<script>
// import FeriadoDialog from './Components/FeriadoDialog'
import CartaoFidelidade from './Components/CartaoFidelidade'

import { refAgenda } from "@/firebaseConfig";

export default {
  components: {
    CartaoFidelidade
  },
  data() {
    return {
      termoQuery: "",
      // refFeriados: refFeriados,
      listaBuscados: [],
      listaFidelidade: [],
      dataIni: "",
      dataFim: "",
      dialog: false,
      valid: true,
      inputRules: [
        (v) => !!v || "Este campo é obrigatório",
        (v) =>
          (v && v.length >= 3) || "Nome precisa ter pelo menos 3 caracteres",
      ],
    };
  },
  methods: {
    async buscarCliente() {
      this.listaFidelidade = []
      this.listaBuscados = []
      let queryText = this.termoQuery
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      // .where('name', '>=', queryText).where('name', '<=', queryText+ '\uf8ff'
      console.log(this.dataIni);
      console.log(this.dataFim);
      let dataIni = new Date(this.dataIni).getTime();
      let dataFim = new Date(this.dataFim).getTime();
      console.log(dataIni);
      console.log(dataFim);

      await refAgenda
        .where("searchTermsArray", "array-contains", queryText.toLowerCase())
        // .orderBy("email")
        .where("dataQuery", ">=", dataIni)
        .where("dataQuery", "<=", dataFim)
        .limit(40)
        .get()
        .then((ref) => {
          ref.forEach((usuario) => {
            // console.log(produto.data().nome);
            this.listaBuscados.push(usuario.data());
          });
        });
        //AGRUPAR POR EMAIL
      for (const agendamento of this.listaBuscados) {
        this.agruparPorEmail(agendamento);
      }
        //REMOVER DUPLICADOS
        this.listaFidelidade = this.removeDuplicates("email")
        console.log(this.listaFidelidade);
    },
    agruparPorEmail(agendamento) {
      let contadorPresenca = 0;
      for (const agendamentoQuery of this.listaBuscados) {
        if (agendamento.cliente.email == agendamentoQuery.cliente.email) {
          contadorPresenca = contadorPresenca + 1;
        }
      }
      this.listaFidelidade.push({
        nome: agendamento.cliente.nome,
        email: agendamento.cliente.email,
        totalVisitas: contadorPresenca,
      });
    },
    removeDuplicates(prop) {
      var newArray = [];
      var lookupObject = {};

      for (var i in this.listaFidelidade) {
        lookupObject[this.listaFidelidade[i][prop]] = this.listaFidelidade[i];
      }

      for (i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    },
    visualizarCartao(item) {
      console.log(item);
      alert("Abrir Dialog");
    },
    async converterAgendamentos(){
      let dataIni = new Date(this.dataIni).getTime();
      let dataFim = new Date(this.dataFim).getTime();

       await refAgenda
        .where("dataQuery", ">=", dataIni)
        .where("dataQuery", "<=", dataFim)
        .limit(1000)
        .get()
        .then((ref) => {
          ref.forEach((usuario) => {
            // console.log(produto.data().nome);
            let agendamento = usuario.data();
            console.log(usuario);
            if(agendamento.cliente.nome){

              agendamento.searchTermsArray = this.gerarTermosParaPesquisa(agendamento.cliente.nome);
              refAgenda.doc(usuario.id).update(agendamento)
              // usuario.ref().update(agendamento);
            }
            console.log(agendamento);
          });
        });
    },
    gerarTermosParaPesquisa(nome){
            //gerar termos para pesquisa
            let searchTermsArray = nome.split(" ")
            searchTermsArray = searchTermsArray.map(term => {
              term = term.toLowerCase();
              term = term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

              return term
            });

            return searchTermsArray;
        }

  },
  created() {
    this.carregarLista();
  },
};
</script>

<style lang="scss" scoped></style>
